import { create } from "zustand";
import { HeaderTab } from "@/domains/playerMenu/constants/headerTab";
import { SubHeaderTab } from "@/domains/playerMenu/constants/subHeaderTab";

type State = {
  isShow: boolean;
  headerTabs: HeaderTab[];
  currHeaderTab: HeaderTab | null;
  subHeaderTabs: Record<HeaderTab, SubHeaderTab[]>;
  currSubHeaderTab: SubHeaderTab | null;
};

type Action = {
  setIsShow: (flag: boolean) => void;
  setHeaderTabs: (tabs: HeaderTab[]) => void;
  changeHeaderTab: (tab: HeaderTab | null) => void;
  changeSubHeaderTab: (tab: SubHeaderTab | null) => void;
};

export const usePlayerMenuStore = create<State & Action>((set) => ({
  isShow: false,
  headerTabs: [],
  currHeaderTab: null,
  subHeaderTabs: {
    [HeaderTab.Character]: [
      SubHeaderTab.Data,
      SubHeaderTab.Documents,
      SubHeaderTab.Estate,
      SubHeaderTab.Vehicle,
      SubHeaderTab.Family,
      SubHeaderTab.Faction,
      SubHeaderTab.Business,
      SubHeaderTab.Skills,
      SubHeaderTab.Statistic,
    ],
    [HeaderTab.Settings]: [
      SubHeaderTab.Basic,
      SubHeaderTab.Sound,
      SubHeaderTab.Control,
      SubHeaderTab.Safety,
      SubHeaderTab.Gameplay,
      SubHeaderTab.Chat,
    ],
  },
  currSubHeaderTab: null,
  setIsShow: (flag) => set(() => ({ isShow: flag })),
  setHeaderTabs: (tabs) => set(() => ({ headerTabs: tabs })),
  changeHeaderTab: (tab) => set(() => ({ currHeaderTab: tab })),
  changeSubHeaderTab: (tab) => set(() => ({ currSubHeaderTab: tab })),
}));
